import { ProjectStatus, ProjectStatusDisplay } from '~/constants';
import { Project } from '~/types/project';


export default function status(project: Project, permissions: any) {
  const status = project?.status;
  const isInvestor = !permissions.isAdmin && permissions.hasProjectInvestorAccess;

  if (project?.reactivatedProject) {
    return 'Reactivated';
  }

  if (project?.isArchived || project?.portfolio?.isArchived) {
    return 'Archived';
  }

  if (status === ProjectStatus.MARKET_QUOTE) {
    return 'Estimate';
  }

  if (status === ProjectStatus.MATCHING && isInvestor) {
    // Investor view of standalone or portfolio project: all bidding-related
    // statuses read "Bidding" (no "Bid Review").
    return 'Bidding';
  }

  if (status === ProjectStatus.MATCHING) {
    if (!project?.bidSummary?.length) {
      // Project is still in review by admins, no investors matched yet
      return 'In Review';
    }
    // Investors have been matched; consolidate bidding/bid-review into "Bidding"
    return 'Bidding';
  }

  return ProjectStatusDisplay[status];
}